import styled, { css } from '../../styles/theme';
import { ButtonType } from '.';
import { rem } from 'polished';

export interface IButtonStyles {
    primary?: boolean;
    secondary?: boolean;
    outline?: boolean;
    disabled?: boolean;
    id?: string;
    btnType?: ButtonType;
}

export const ButtonStyles = css<IButtonStyles>`
    border: none;
    white-space: nowrap;
    cursor: pointer;
    text-transform: uppercase;
    font-size: ${({ theme }) => theme.fontSizes.textBase};
    font-weight: ${({ theme }) => theme.fontWeights.textBold};

    ${({ btnType }) =>
        btnType === ButtonType.DELETE &&
        css`
            cursor: pointer;
            background: ${({ theme }) => theme.colors.primary};
            color: ${({ theme }) => theme.colors.white};
            &:focus-visible,
            &:hover {
                opacity: 0.8;
            }
            &:disabled {
                opacity: 0.7;
            }
        `}

    &:not(:last-of-type) {
        margin-right: ${rem(10)};
    }

    ${({ disabled }) =>
        disabled &&
        css`
            cursor: default;
            pointer-events: none;
        `}

    ${({ primary, disabled }) =>
        primary &&
        css`
            background: ${({ theme }) => theme.colors.primary};
            color: ${({ theme }) => theme.colors.white};

            ${disabled
                ? css`
                      opacity: 0.6;
                  `
                : css`
                      &:focus-visible,
                      &:hover {
                          background: ${({ theme }) => theme.colors.primaryHover};
                      }
                  `}
        `}

    ${({ secondary, disabled }) =>
        secondary &&
        css`
            background: ${({ theme }) => theme.colors.secondary};
            color: ${({ theme }) => theme.colors.white};

            ${disabled
                ? css`
                      background: ${({ theme }) => theme.colors.secondaryDisabled};
                      color: ${({ theme }) => theme.colors.white};
                  `
                : css`
                      &:focus-visible,
                      &:hover {
                          background: ${({ theme }) => theme.colors.secondaryHover};
                      }
                  `}
        `}
`;

export const ButtonStyled = styled.button<IButtonStyles>`
    ${ButtonStyles}
`;
